var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-group"},_vm._l((_vm.tags),function(t){return _c('span',{key:t.text,class:['tag', `tag-${t.type}`]},[_vm._v(_vm._s(t.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }